(function () {
  var STORAGE_KEY = 'braze_beid'
  var COOKIE_KEY = 'beid'
  var POLL_MS = 100
  var MAX_WAIT_MS = 15000

  function trackingAllowed () {
    var cp = window.Shopify && window.Shopify.customerPrivacy
    if (!cp) return false

    try {
      return !!(
        (typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) ||
        (typeof cp.marketingAllowed === 'function' && cp.marketingAllowed())
      )
    } catch (e) {
      return false
    }
  }

  function getCookieValue (name) {
    var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : null
  }

  function getBeid () {
    if (!trackingAllowed()) return null

    if (window.__BRAZE_BEID) return window.__BRAZE_BEID

    var cookieBeid = getCookieValue(COOKIE_KEY)
    if (cookieBeid) return cookieBeid

    try {
      return localStorage.getItem(STORAGE_KEY)
    } catch (e) {
      return null
    }
  }

  function getBrazeSdk () {
    return window.braze || window.appboy || null
  }

  function isBrazeReady (sdk) {
    return !!(
      sdk &&
      typeof sdk.changeUser === 'function' &&
      typeof sdk.isInitialized === 'function' &&
      sdk.isInitialized()
    )
  }

  function getCurrentUserId (sdk) {
    try {
      var user = sdk && typeof sdk.getUser === 'function' ? sdk.getUser() : null
      return user && typeof user.getUserId === 'function' ? user.getUserId() : null
    } catch (e) {
      return null
    }
  }

  function identifyIfReady () {
    var beid = getBeid()
    var sdk = getBrazeSdk()

    if (!beid || !isBrazeReady(sdk)) return false
    if (getCurrentUserId(sdk) === beid) return true

    sdk.changeUser(beid)

    if (typeof sdk.requestImmediateDataFlush === 'function') {
      sdk.requestImmediateDataFlush()
    }

    return true
  }

  function retryIdentify (maxWaitMs) {
    var startedAt = Date.now()

    ;(function waitForBraze () {
      if (identifyIfReady()) return
      if (Date.now() - startedAt >= maxWaitMs) return
      setTimeout(waitForBraze, POLL_MS)
    })()
  }

  retryIdentify(MAX_WAIT_MS)

  window.addEventListener('braze:beid-ready', function () {
    retryIdentify(MAX_WAIT_MS)
  })

  window.addEventListener('pageshow', function () {
    retryIdentify(3000)
  })

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      retryIdentify(3000)
    }
  })
})()
